/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ADMIN_USER_BASE_URL } from "../Constants/SagaConstants";
import { IAdminPermissionsDataResult } from "../Interfaces/Admin/IAdminPermissionsDataResult";
import { IApiResult2 } from "../Interfaces/IApiResult";
import { get, IHttpResponse } from "./ApiUtils";

/**
 * Get full detail of individual application
 */
export async function getAdminPermissions(
  adminEmail: string
): Promise<IHttpResponse<IApiResult2<IAdminPermissionsDataResult>>> {
  return await get<IApiResult2<IAdminPermissionsDataResult>>(
    ADMIN_USER_BASE_URL + "permissions/" + adminEmail,
    true
  );
}
